import type { Store } from '@jane/shared/types';
import { minimumAgeValidation, minimumDateValidation } from '@jane/shared/util';

import { formatBirthdate } from '../dates/formatBirthdate';

export const validateBirthdateField = (value: string, store: Store) => {
  const birthDate = formatBirthdate(value);

  const isDateBefore1900 = minimumDateValidation(birthDate);

  if (isDateBefore1900) {
    return 'You must be born after 1900';
  }

  const meetsMinimumAgeRequirement = minimumAgeValidation({
    ageMinimum: store.checkout_age_minimum,
    value: birthDate,
  });

  return (
    meetsMinimumAgeRequirement ||
    `Minimum age must be ${store.checkout_age_minimum}`
  );
};
